<template>
  <div class="home-wrap">
    <div style="width: 100vw">
      <video v-if="type == 1" style="width: 100vw" autoplay loop muted="muted" controls disablepictureinpicture controlslist="nodownload noremoteplayback">
        <source :src="vurl" type="video/mp4" />
      </video>
      <el-carousel v-if="type == 2" height="480px">
        <el-carousel-item v-for="item in picUrlList" :key="item">
          <el-image :src="item" fit="fill" style="width: 100vw; height: 480px" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="part-1 max-width">
      <hot-news class="hot-news" />
      <policy-inquiries class="policy-inquiries" />
    </div>
    <div class="part-2 max-width">
      <!-- <activity-list /> -->
      <service-market />
      <!-- <product-list class="mb-30" /> -->
      <!-- <works-list class="mb-30" /> -->
      <!-- <quick-entry class="mb-30" /> -->
      <out-link />
    </div>
  </div>
</template>

<script>
import HotNews from './components/HotNews'
import PolicyInquiries from './components/PolicyInquiries'
import ServiceMarket from './components/ServiceMarket'
import QuickEntry from './components/QuickEntry'
import OutLink from './components/OutLink'
import ProductList from './components/ProductList'
import WorksList from './components/WorksList'
import ActivityList from './components/ActivityList'
export default {
  name: 'HomePage',
  components: { HotNews, PolicyInquiries, ServiceMarket, QuickEntry, OutLink, ProductList, WorksList, ActivityList },
  data() {
    return {
      type: 1,
      vurl: 'https://nbrc.gov.cn/images/%E5%BC%95%E6%89%8D-%E6%9C%89%E8%83%8C%E6%99%AF.mp4',
      picUrlList: [],
      // videoUrl: window.location.origin + '/images/%E5%BC%95%E6%89%8D-%E6%9C%89%E8%83%8C%E6%99%AF.mp4',
    }
  },
  computed: {
    videoUrl() {
      if (process.env.NODE_ENV === 'development') {
        return 'http://10.68.190.191:8602/images/%E5%BC%95%E6%89%8D-%E6%9C%89%E8%83%8C%E6%99%AF.mp4'
      }
      return window.location.origin + '/images/%E5%BC%95%E6%89%8D-%E6%9C%89%E8%83%8C%E6%99%AF.mp4'
    },
  },
  mounted() {
    this.getUrlInfo()
  },
  methods: {
    getUrlInfo() {
      this.$http({ method: 'get', url: '/zzmh/api/advertisement/info' })
        .then((res) => {
          if (res.data) {
            this.type = res.data.type
            this.vurl = res.data.videoUrl
            this.picUrlList = res.data.pictureUrl ? res.data.pictureUrl.split(',') : []
          }
          // console.log(res)
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .part-1 {
    display: flex;
    // flex-wrap: nowrap;
    padding: 1vw 8.3333vw 2vw;
    .hot-news {
      width: 66.666%;
      margin-right: 2.6%;
    }
    .policy-inquiries {
      width: 33.333%;
    }
  }
  .part-2 {
    padding: 0 8.3333vw;
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
    .part-1 {
      flex-direction: column;
      .hot-news {
        width: 100%;
      }
      .policy-inquiries {
        width: 100%;
      }
    }
  }
}
</style>
